var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeoplesearchAmico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.82,84.16l72.5-41.86c1.3-.75,2.35-.14,2.35,1.36V136a5.19,5.19,0,0,1-2.35,4.07l-72.5,41.78c-1.3.75-2.35.14-2.35-1.36V88.23A5.19,5.19,0,0,1,288.82,84.16Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.51,210.26,142,168.4c1.3-.75,2.35-.14,2.35,1.36V262a5.17,5.17,0,0,1-2.35,4.07L69.51,307.9c-1.3.75-2.35.14-2.35-1.36V214.33A5.19,5.19,0,0,1,69.51,210.26Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.38,147.32l72.5-41.86c1.3-.75,2.35-.14,2.35,1.36v92.29a5.19,5.19,0,0,1-2.35,4.07L179.38,245c-1.3.75-2.35.14-2.35-1.36V151.39A5.2,5.2,0,0,1,179.38,147.32Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.44,286.61c44.57-25.71,82.17-90.92,82.17-142.36,0-9.24-1.34-26.52-10.46-37.31l-.15,0a33.45,33.45,0,0,0-5.44-.42,46.21,46.21,0,0,0-10.73,1.35A79.61,79.61,0,0,0,258,116.45c-44.55,25.72-82.19,90.93-82.19,142.37a82.75,82.75,0,0,0,2.88,22.28,40.15,40.15,0,0,0,7.67,15,31.1,31.1,0,0,0,5.51.46C201.2,296.6,212.1,293.15,223.44,286.61Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.51,148.05,285,86.56c1.9-1.1,3.45-.21,3.45,2V224.12a7.63,7.63,0,0,1-3.45,6l-106.5,61.38c-1.91,1.1-3.46.21-3.46-2V154A7.65,7.65,0,0,1,178.51,148.05Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-16"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-16",
    cx: 250.27,
    cy: 352.04,
    rx: 214.86,
    ry: 124.05,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-16"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-16",
    cx: 365,
    cy: 419.86,
    rx: 42.95,
    ry: 26.93,
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443,323.28l-8.91-5s-.84-16.27.44-29.25c1.79-18.24,13.57-40.2,27.63-35s-6.45,23.73-11,39.21S443,323.28,443,323.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.85,321.37h0a.47.47,0,0,0,.46-.49c-1.38-40.53,18.8-60.93,19-61.13a.47.47,0,1,0-.66-.67c-.21.2-20.68,20.89-19.29,61.84A.47.47,0,0,0,438.85,321.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.89,326.1l-5.57-3.22s-.95-11.5,4.69-25.48c4.91-12.17,17.1-22.26,23.22-20.14s6,6.47,3,11S452.06,303.71,447.89,326.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,324.87h0a.47.47,0,0,0,.48-.47c-.11-25.63,23.95-43,24.2-43.13a.48.48,0,0,0,.11-.66.47.47,0,0,0-.66-.11c-.25.17-24.71,17.78-24.6,43.9A.47.47,0,0,0,445,324.87Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--characters-boxes--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.94,248.65h0l-5.79-3.31h0a1.87,1.87,0,0,1-.74-1.67V205.09a5.54,5.54,0,0,1,1-2.88l5.76,3.32a5.43,5.43,0,0,0-.94,2.86V247A1.8,1.8,0,0,0,282.94,248.65Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.94,248.65h0l-5.79-3.31h0a1.87,1.87,0,0,1-.74-1.67V205.09a5.54,5.54,0,0,1,1-2.88l5.76,3.32a5.43,5.43,0,0,0-.94,2.86V247A1.8,1.8,0,0,0,282.94,248.65Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.78,203.85l80.78-46.63c1.45-.84,2.62-.16,2.62,1.51v38.66a5.76,5.76,0,0,1-2.62,4.53l-80.78,46.56c-1.44.83-2.62.15-2.62-1.52V208.39A5.82,5.82,0,0,1,284.78,203.85Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.78,203.85l80.78-46.63c1.45-.84,2.62-.16,2.62,1.51v38.66a5.76,5.76,0,0,1-2.62,4.53l-80.78,46.56c-1.44.83-2.62.15-2.62-1.52V208.39A5.82,5.82,0,0,1,284.78,203.85Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.62,153.73l5.7,3.25a1.9,1.9,0,0,0-1.76.23l-80.78,46.64a5.18,5.18,0,0,0-1.68,1.68l-5.76-3.32a5,5,0,0,1,1.65-1.66l80.78-46.64a2.36,2.36,0,0,1,1.17-.35A1.4,1.4,0,0,1,361.62,153.73Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.62,153.73l5.7,3.25a1.9,1.9,0,0,0-1.76.23l-80.78,46.64a5.18,5.18,0,0,0-1.68,1.68l-5.76-3.32a5,5,0,0,1,1.65-1.66l80.78-46.64a2.36,2.36,0,0,1,1.17-.35A1.4,1.4,0,0,1,361.62,153.73Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.1,207.42,359.24,168c.7-.4,1.26-.12,1.26.63a2.69,2.69,0,0,1-1.26,2.09l-68.14,39.4c-.69.4-1.26.12-1.26-.63A2.7,2.7,0,0,1,291.1,207.42Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.1,235l68.14-39.4c.7-.4,1.26-.12,1.26.64a2.67,2.67,0,0,1-1.26,2.08L291.1,237.68c-.69.4-1.26.11-1.26-.64A2.72,2.72,0,0,1,291.1,235Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.1,221.19l68.14-39.41c.7-.4,1.26-.11,1.26.64a2.71,2.71,0,0,1-1.26,2.09l-68.14,39.4c-.69.4-1.26.11-1.26-.64A2.7,2.7,0,0,1,291.1,221.19Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.1,228.07l68.14-39.4c.7-.4,1.26-.12,1.26.63a2.69,2.69,0,0,1-1.26,2.09l-68.14,39.4c-.69.4-1.26.12-1.26-.63A2.7,2.7,0,0,1,291.1,228.07Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.1,214.3l68.14-39.4c.7-.4,1.26-.12,1.26.64a2.67,2.67,0,0,1-1.26,2.08L291.1,217c-.69.4-1.26.11-1.26-.64A2.72,2.72,0,0,1,291.1,214.3Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.5,189.77h0L277,186.64a1.86,1.86,0,0,1-.74-1.67V82.35a5.47,5.47,0,0,1,1-2.88l5.36,3.1a5.42,5.42,0,0,0-.89,2.78V188.08A1.8,1.8,0,0,0,282.5,189.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.5,33.83a2.19,2.19,0,0,0-1.38.34L284.34,80.81a5.3,5.3,0,0,0-1.73,1.76l-5.37-3.1a5.23,5.23,0,0,1,1.65-1.66l80.78-46.63a2.31,2.31,0,0,1,1.17-.36,1.4,1.4,0,0,1,.68.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,80.81l80.78-46.63c1.45-.84,2.62-.16,2.62,1.51V138.51a5.76,5.76,0,0,1-2.62,4.53L284.35,189.6c-1.45.83-2.63.15-2.63-1.52V85.35A5.82,5.82,0,0,1,284.34,80.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.82,84.16l72.5-41.86c1.3-.75,2.35-.14,2.35,1.36V136a5.19,5.19,0,0,1-2.35,4.07l-72.5,41.78c-1.3.75-2.35.14-2.35-1.36V88.23A5.19,5.19,0,0,1,288.82,84.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-16)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.09,122a10.8,10.8,0,0,0-13.16-4.75s-.42,7.73,3.54,18.83c0,0,17.25,25.14,20.69,27.48l4.77-15.82S352.34,127.09,349.09,122Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.82,127.37c-4.07,1.55-3.46,6-3.33,9.95.07,2.43.47,6.55.73,12.2l1.16,18.19-.26,39.46c13.23,4.51,30.06.54,44.18-15.15,0,0-.79-50.5-.79-58.79,0-.38,0-.75,0-1.13-.5-11.34-6.13-16.19-12.56-14.83-2.06.44-6.52,1.86-9.47,2.78l-8.1,2.62S310.88,125.82,306.82,127.37Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.82,127.37c-4.07,1.55-3.46,6-3.33,9.95.07,2.43.47,6.55.73,12.2l1.16,18.19-.26,39.46c13.23,4.51,30.06.54,44.18-15.15,0,0-.79-50.5-.79-58.79,0-.38,0-.75,0-1.13-.5-11.34-6.13-16.19-12.56-14.83-2.06.44-6.52,1.86-9.47,2.78l-8.1,2.62S310.88,125.82,306.82,127.37Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.46,88.08c0-3.65.57-8.44,4.28-10.19,1.88-.89,4.56-1.26,6.35-.1s2.93,2.8,2.61,5.08a8.07,8.07,0,0,1-2.43,4.44,1.39,1.39,0,0,0-.47.66,1.35,1.35,0,0,0,.05.63c.48,2.25.45,4.83-1.08,6.55a4.69,4.69,0,0,1-4.25,1.49,5.89,5.89,0,0,1-4-3.28A11.61,11.61,0,0,1,337.46,88.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,100.9s2.06,10.61,2.88,12.22a3.15,3.15,0,0,0,2.53,1.67l-.14-7.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.53,84.23s-1.91.47-2,.52a6,6,0,0,0-2.31,1.55,4.48,4.48,0,0,0-1.12,4A6.25,6.25,0,0,0,311.79,93a6.35,6.35,0,0,0-1.39,2.16,3.61,3.61,0,0,0,0,2.53,5.82,5.82,0,0,0,.82,1.32c.73.93,1.59,1.84,2.85,1.7.92-.1,1.85-.25,2.77-.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,100.07c-.77.75-1.88-.68-2.84-1.58s-4.08-1.64-5.64,2.57,1.38,8.6,3.84,8.84c4.24.4,4.88-2.91,4.88-2.91l.14,17.42c4.63,9.69,23.71,6,14-4.06V115a24.32,24.32,0,0,0,5.71-1.2c3.12-1.39,5.09-4.76,6-8.91,1.52-6.67,1.39-10.62.88-22.65-.35-8.26-15.08-10.81-22.42-3.51S318,100.07,318,100.07Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.14,98.49c-.5-.39-.45-1.53-.48-2.08a35.6,35.6,0,0,1,.07-4c.13-2.1.71-4.3.23-6.36a5.39,5.39,0,0,1-.21-2.32,1.85,1.85,0,0,1,1.54-1.56,7.16,7.16,0,0,1,8.18-9.56,6.66,6.66,0,0,1,5-4.64,8.46,8.46,0,0,1,4.06.14,4.75,4.75,0,0,1,3.08,2.61c.83-1.78,3.7-3.38,6.32-3.08,2.2.26,4.46,1.62,5.21,3.4a9.07,9.07,0,0,1,0,7.34,6.26,6.26,0,0,1-4.1,3.24,6.93,6.93,0,0,1-5.24-.82A4.4,4.4,0,0,1,335.65,85a7.49,7.49,0,0,1-3.9.19,9.43,9.43,0,0,1-3.25-2.09A4.68,4.68,0,0,1,325.59,87a5.88,5.88,0,0,1-4.93-.37,13.76,13.76,0,0,1,.62,3.67,4.09,4.09,0,0,1-.29,1.9,1.71,1.71,0,0,1-1.52,1,11.84,11.84,0,0,1,.75,5.74,3.19,3.19,0,0,1-.86,2.09C317.63,102.63,316.21,99.33,315.14,98.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.54,85.22l-4.7-1.65c.67-1.73,2.26-2.76,3.56-2.31S316.2,83.49,315.54,85.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.33,115s-7,.24-9.4-.6a6,6,0,0,1-3.37-2.94,10.33,10.33,0,0,0,1.92,4c1.78,2.15,10.85,1.66,10.85,1.66Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.53,96.09a2.14,2.14,0,0,1-1.4,2c-.77.21-1.4-.38-1.4-1.3a2.15,2.15,0,0,1,1.4-2C329.9,94.58,330.53,95.17,330.53,96.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.47,91.51l-3.4,2.16a2.56,2.56,0,0,1,1-2.81A1.59,1.59,0,0,1,329.47,91.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.7,105.52l3.18.52a2.18,2.18,0,0,1-2.16,1.8C331.84,107.7,331.38,106.66,331.7,105.52Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.17,90.84l-2.72-1.69c.55-1.05,1.61-1.52,2.36-1.06A2.1,2.1,0,0,1,343.17,90.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.46,93.28a2.14,2.14,0,0,1-1.39,2c-.77.21-1.4-.38-1.4-1.3a2.16,2.16,0,0,1,1.4-2C341.84,91.77,342.46,92.35,342.46,93.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.88 93.67 335.04 103.39 340.04 100.78 334.88 93.67",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.29,210.6a19.45,19.45,0,0,0,2.23,7.5,26.52,26.52,0,0,0,5,5.79,1.22,1.22,0,0,1,.43.63c.07.52-.52.88-1,1a4.81,4.81,0,0,1-3.16-.62,9.51,9.51,0,0,1-1.95-1.51c-.2-.18-1.44-1.06-1.44-1.26a19.53,19.53,0,0,0,2.18,6,45.6,45.6,0,0,1,2.79,5c.47,1.13.69,2.59-.18,3.45a3.14,3.14,0,0,1-1.27.65,9.31,9.31,0,0,1-9.07-2.34,15.43,15.43,0,0,1-2.54-3.74,24.26,24.26,0,0,1-1.08-2.31A25.36,25.36,0,0,1,294,224.6c-.77-3.47-1.06-7-1.59-10.48a197.44,197.44,0,0,1-1.88-33.47c1.8-37.06,4.33-49.59,16.31-53.28,3.39,2.52,4.91,13.31,1.34,22.93a288.53,288.53,0,0,0-3.48,32.46c-.22,5.14-1.05,15.5-.81,20.64C304,205.7,304,208,304.29,210.6Z",
    style: {
      fill: "#b16668"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.87,375.05h0l-5.79-3.31h0a1.87,1.87,0,0,1-.74-1.67V331.5a5.54,5.54,0,0,1,1-2.88L64,331.94a5.43,5.43,0,0,0-.94,2.86v38.56A1.8,1.8,0,0,0,63.87,375.05Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.87,375.05h0l-5.79-3.31h0a1.87,1.87,0,0,1-.74-1.67V331.5a5.54,5.54,0,0,1,1-2.88L64,331.94a5.43,5.43,0,0,0-.94,2.86v38.56A1.8,1.8,0,0,0,63.87,375.05Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.71,330.26l80.78-46.64c1.44-.84,2.62-.16,2.62,1.51v38.66a5.81,5.81,0,0,1-2.63,4.54L65.71,374.88c-1.45.83-2.62.15-2.62-1.52V334.79A5.76,5.76,0,0,1,65.71,330.26Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.71,330.26l80.78-46.64c1.44-.84,2.62-.16,2.62,1.51v38.66a5.81,5.81,0,0,1-2.63,4.54L65.71,374.88c-1.45.83-2.62.15-2.62-1.52V334.79A5.76,5.76,0,0,1,65.71,330.26Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.55,280.14l5.7,3.25a1.9,1.9,0,0,0-1.76.23L65.71,330.26A5.18,5.18,0,0,0,64,331.94l-5.76-3.32A5,5,0,0,1,59.92,327l80.78-46.64a2.36,2.36,0,0,1,1.17-.35A1.4,1.4,0,0,1,142.55,280.14Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.55,280.14l5.7,3.25a1.9,1.9,0,0,0-1.76.23L65.71,330.26A5.18,5.18,0,0,0,64,331.94l-5.76-3.32A5,5,0,0,1,59.92,327l80.78-46.64a2.36,2.36,0,0,1,1.17-.35A1.4,1.4,0,0,1,142.55,280.14Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,333.82l68.14-39.4c.69-.4,1.26-.12,1.26.64a2.7,2.7,0,0,1-1.26,2.08L72,336.54c-.7.4-1.26.12-1.26-.63A2.69,2.69,0,0,1,72,333.82Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,361.36,140.17,322c.69-.4,1.26-.11,1.26.64a2.7,2.7,0,0,1-1.26,2.08L72,364.08c-.7.4-1.26.11-1.26-.64A2.67,2.67,0,0,1,72,361.36Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,347.59l68.14-39.4c.69-.4,1.26-.12,1.26.63a2.72,2.72,0,0,1-1.26,2.09L72,350.31c-.7.4-1.26.12-1.26-.63A2.67,2.67,0,0,1,72,347.59Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,354.47l68.14-39.4c.69-.4,1.26-.12,1.26.63a2.7,2.7,0,0,1-1.26,2.09L72,357.19c-.7.4-1.26.12-1.26-.63A2.69,2.69,0,0,1,72,354.47Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,340.71l68.14-39.41c.69-.4,1.26-.11,1.26.64a2.7,2.7,0,0,1-1.26,2.08L72,343.43c-.7.4-1.26.11-1.26-.64A2.67,2.67,0,0,1,72,340.71Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.53,316h0L58,312.91a1.86,1.86,0,0,1-.74-1.67V208.62a5.47,5.47,0,0,1,1-2.88l5.36,3.1a5.42,5.42,0,0,0-.89,2.78V314.35A1.8,1.8,0,0,0,63.53,316Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.53,160.1a2.19,2.19,0,0,0-1.38.34L65.37,207.08a5.3,5.3,0,0,0-1.73,1.76l-5.37-3.1a5.23,5.23,0,0,1,1.65-1.66l80.78-46.63a2.31,2.31,0,0,1,1.17-.36,1.4,1.4,0,0,1,.68.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.37,207.07l80.78-46.63c1.44-.84,2.62-.16,2.62,1.51V264.77a5.82,5.82,0,0,1-2.62,4.54L65.37,315.86c-1.45.83-2.62.16-2.62-1.51V211.61A5.8,5.8,0,0,1,65.37,207.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.51,210.26,142,168.4c1.3-.75,2.35-.14,2.35,1.36V262a5.17,5.17,0,0,1-2.35,4.07L69.51,307.9c-1.3.75-2.35.14-2.35-1.36V214.33A5.19,5.19,0,0,1,69.51,210.26Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-16)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.72,248.75c-5.66-7.35-15-6.31-15-6.31a84.29,84.29,0,0,0,4.63,18.7s17.26,25.13,20.7,27.48l4.77-15.83S131.39,253.53,127.72,248.75Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7,242.8a21.4,21.4,0,0,1,7.58-1c4.07.26,9.08,4.87,12.07,9.67,4,6.42,6.66,11,6.66,11s-1.33,7.54-11.62,10.79l-9.52-12.42Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7,242.8a21.4,21.4,0,0,1,7.58-1c4.07.26,9.08,4.87,12.07,9.67,4,6.42,6.66,11,6.66,11s-1.33,7.54-11.62,10.79l-9.52-12.42Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.44,272.26l-1.33,21,1.07,39.29c13.23,4.51,30.06.54,44.18-15.15,0,0-.58-52.18-2.42-61.09-2.21-10.73-7.48-16.6-18.16-12.78l-10.47,4.18L86.54,252S84.44,268.2,84.44,272.26Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.44,272.26l-1.33,21,1.07,39.29c13.23,4.51,30.06.54,44.18-15.15,0,0-.58-52.18-2.42-61.09-2.21-10.73-7.48-16.6-18.16-12.78l-10.47,4.18L86.54,252S84.44,268.2,84.44,272.26Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.26,213.7c0,8.9,6.25,14.44,14,12.37s14-10.95,14-19.85-6.65-8.9-14.36-6.83S98.26,204.8,98.26,213.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,232.32l-2.34-2.71.95-3.9-2-15.41a3.85,3.85,0,0,0-4.08,2.08c-3.35,6.08,4.46,24.77,5.13,26.07a3.16,3.16,0,0,0,2.53,1.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.73,225.4c-.77.75-1.88-.68-2.84-1.58s-4.08-1.64-5.64,2.57,1.37,8.61,3.83,8.84c4.25.4,4.88-2.91,4.88-2.91l.15,18.1c7.11,7.55,23.49,3.86,14-4.69l0-5.37a24.71,24.71,0,0,0,5.72-1.19c3.12-1.4,5.08-4.76,6-8.92,1.52-6.66,2.1-11.87.81-23.84-1.42-13.12-15-9.62-22.36-2.32S95.73,225.4,95.73,225.4Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.59,226.67c-1.3-.34-2.15-2.42-2.7-2.85s-.46-1.53-.48-2.08a34,34,0,0,0-.1-4.05,24.81,24.81,0,0,1-.46-4.3c0-3,.07-7.18,1.3-9.95,2.27-5.11,5.81-6.4,10.08-7.77,3.28-1,6.87-.9,10.09-2.12a25.2,25.2,0,0,0,7.13-4.8c.79-.67,1.89-1.37,2.76-.82a2.19,2.19,0,0,1,.8,1.29,11.45,11.45,0,0,1,.43,4.76,2.46,2.46,0,0,0,2-.8c.15-.18.31-.39.54-.39s.48.37.53.68a8.93,8.93,0,0,1-.35,4c-1.84,6.44-8.24,10.34-14.77,11.84a24.45,24.45,0,0,1-11.21.4,1.76,1.76,0,0,0-1.3.23,2,2,0,0,0-.7,1c-.71,1.83,0,5.57-.18,8.09-.27,3.07-.74,5.67-1.9,7.12A1.3,1.3,0,0,1,95.59,226.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2,210.56l-4.69-1.66c.66-1.73,2.25-2.76,3.55-2.3S92.87,208.82,92.2,210.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.07,240.36s-7,.25-9.39-.6a6,6,0,0,1-3.37-2.94,10.39,10.39,0,0,0,1.91,4c1.78,2.15,10.85,1.66,10.85,1.66Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4,221.36a2.14,2.14,0,0,1-1.39,2c-.78.2-1.4-.38-1.4-1.31a2.15,2.15,0,0,1,1.4-2C107.78,219.85,108.4,220.43,108.4,221.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.16,215.29l-3,2.7a2.64,2.64,0,0,1,.7-2.93A1.37,1.37,0,0,1,106.16,215.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.44,230.8l3.19.53a2.2,2.2,0,0,1-2.17,1.79C109.59,233,109.13,231.94,109.44,230.8Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.2,212.67,118.48,211c.55-1,1.61-1.52,2.36-1A2.08,2.08,0,0,1,121.2,212.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.61,217.62a2.15,2.15,0,0,1-1.4,2c-.77.21-1.39-.38-1.39-1.3a2.15,2.15,0,0,1,1.39-2.05C120,216.11,120.61,216.69,120.61,217.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.11 217.7 113.27 227.43 118.27 224.81 113.11 217.7",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.88,312.87c4.4-46.94,10.38-58.41,19-59.59,3.38,2.52,4.45,13.3,2.06,24.48,0,0-4.88,25.31-5.31,34.42-.38,8-2.59,17.8-1.61,24.1.18,1.11.76,4.35,1.36,5.1,2,2.46,1.51,3.6,3,5.52,1.2,1.5,3.19,2.4,3,3-.29.72-1.6,1.65-3.68.69a8.33,8.33,0,0,1-3-2.73s.22,3,3,7.56c2.61,4.37,3.38,8.93-3.89,8.09-4.11-.47-7.13-1.63-9.79-12.23-.74-2.93-1.34-8.25-1.92-12.08C68.39,328.15,67.27,319.33,67.88,312.87Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,251.85s-8.71,1.71-11.14,9.81c-2,6.84-3.66,13-5.82,27.36A16.12,16.12,0,0,0,87.13,292s4.6-18.73,5.06-27.15C92.69,255.63,87,251.85,87,251.85Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,251.85s-8.71,1.71-11.14,9.81c-2,6.84-3.66,13-5.82,27.36A16.12,16.12,0,0,0,87.13,292s4.6-18.73,5.06-27.15C92.69,255.63,87,251.85,87,251.85Z",
    style: {
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.5,310.89h0l-5.79-3.31h0a1.89,1.89,0,0,1-.74-1.67V267.34a5.54,5.54,0,0,1,1-2.88l5.76,3.32a5.42,5.42,0,0,0-.93,2.86V309.2A1.8,1.8,0,0,0,173.5,310.89Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5,310.89h0l-5.79-3.31h0a1.89,1.89,0,0,1-.74-1.67V267.34a5.54,5.54,0,0,1,1-2.88l5.76,3.32a5.42,5.42,0,0,0-.93,2.86V309.2A1.8,1.8,0,0,0,173.5,310.89Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.35,266.1l80.77-46.64c1.45-.84,2.62-.16,2.62,1.51v38.66a5.76,5.76,0,0,1-2.62,4.53l-80.77,46.56c-1.45.83-2.62.15-2.62-1.52V270.63A5.76,5.76,0,0,1,175.35,266.1Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.35,266.1l80.77-46.64c1.45-.84,2.62-.16,2.62,1.51v38.66a5.76,5.76,0,0,1-2.62,4.53l-80.77,46.56c-1.45.83-2.62.15-2.62-1.52V270.63A5.76,5.76,0,0,1,175.35,266.1Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.18,216l5.7,3.25a1.9,1.9,0,0,0-1.76.23L175.34,266.1a5.18,5.18,0,0,0-1.68,1.68l-5.76-3.32a5,5,0,0,1,1.65-1.66l80.78-46.64a2.4,2.4,0,0,1,1.18-.35A1.33,1.33,0,0,1,252.18,216Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.18,216l5.7,3.25a1.9,1.9,0,0,0-1.76.23L175.34,266.1a5.18,5.18,0,0,0-1.68,1.68l-5.76-3.32a5,5,0,0,1,1.65-1.66l80.78-46.64a2.4,2.4,0,0,1,1.18-.35A1.33,1.33,0,0,1,252.18,216Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.66,269.66l68.15-39.4c.69-.4,1.25-.12,1.25.63a2.69,2.69,0,0,1-1.25,2.09l-68.15,39.4c-.69.4-1.25.12-1.25-.63A2.71,2.71,0,0,1,181.66,269.66Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.66,297.2l68.15-39.41c.69-.4,1.25-.11,1.25.64a2.69,2.69,0,0,1-1.25,2.08l-68.15,39.41c-.69.4-1.25.11-1.25-.64A2.69,2.69,0,0,1,181.66,297.2Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.66,283.43,249.81,244c.69-.4,1.25-.12,1.25.63a2.71,2.71,0,0,1-1.25,2.09l-68.15,39.4c-.69.4-1.25.12-1.25-.64A2.69,2.69,0,0,1,181.66,283.43Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.66,290.31l68.15-39.4c.69-.4,1.25-.12,1.25.63a2.69,2.69,0,0,1-1.25,2.09L181.66,293c-.69.4-1.25.12-1.25-.63A2.71,2.71,0,0,1,181.66,290.31Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.66,276.55l68.15-39.41c.69-.4,1.25-.11,1.25.64a2.69,2.69,0,0,1-1.25,2.08l-68.15,39.41c-.69.4-1.25.11-1.25-.64A2.69,2.69,0,0,1,181.66,276.55Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.39,253.1h0L167.9,250a1.86,1.86,0,0,1-.74-1.67V145.68a5.47,5.47,0,0,1,1-2.88l5.36,3.1a5.42,5.42,0,0,0-.89,2.78V251.41A1.8,1.8,0,0,0,173.39,253.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.39,97.16a2.19,2.19,0,0,0-1.38.34l-80.78,46.64a5.3,5.3,0,0,0-1.73,1.76l-5.37-3.1a5.23,5.23,0,0,1,1.65-1.66l80.78-46.63a2.31,2.31,0,0,1,1.17-.36,1.4,1.4,0,0,1,.68.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.23,144.14,256,97.5c1.45-.83,2.62-.16,2.62,1.52V201.84a5.76,5.76,0,0,1-2.62,4.53l-80.78,46.55c-1.44.84-2.62.16-2.62-1.51V148.68A5.81,5.81,0,0,1,175.23,144.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.38,147.32l72.5-41.86c1.3-.75,2.35-.14,2.35,1.36v92.29a5.19,5.19,0,0,1-2.35,4.07L179.38,245c-1.3.75-2.35.14-2.35-1.36V151.4A5.21,5.21,0,0,1,179.38,147.32Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-16)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.12,229.65c-10.73-37.83-10.85-44-10.21-48.46,9.74-2.35,14,4.33,16.6,15.59,1.25,5.41,4.85,26,7.08,34.61,2,7.55,4.42,15.65,7.36,21a3.22,3.22,0,0,0,2.41,1.69c2.73.39,3.54,1.92,5.76,3.06,1.74.88,3,.66,2.95,1.27a3.41,3.41,0,0,1-2.75,2.72,9.6,9.6,0,0,1-3.27-.21,18.33,18.33,0,0,0,4.76,4.36c4.28,2.77,5.61,7-1.8,9.09-2.91.81-8.33-.11-14.78-8.82a49.32,49.32,0,0,1-5.31-10C245.25,246.26,242.26,237.21,240.12,229.65Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.07,185.54s-10.62,3.77-13.36,5.06c7,8.4-1.38,31.32-1.38,31.32l4.47,15.44,33.6-11.77c5.56-14,6.65-20.35,6.16-24.19-1.11-8.7-6.31-14.41-13.65-20.21Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.3,176.22l-17.52,5.5a17.85,17.85,0,0,1-23.2-17V161h0c0-12.56,8.82-25.1,19.7-28l1.47-.39c10.88-2.92,19.7,4.9,19.7,17.46v3.51C239.45,164.82,239.3,176.22,239.3,176.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.36,138.21c-1.08-1.06-2.89-.66-4.05.89l2.16,2.14a2.46,2.46,0,0,0-1.48.29,4.44,4.44,0,0,0-2.22,4.51l5.61-2.87a3.44,3.44,0,0,0-.11-.38C206.33,141.25,206.4,139.24,205.36,138.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.78,142.4c2,1.31,4.8,3.66,4.54,16.87-.22,11.19-3.35,14.78-4.92,16s-4.6,1.54-7.54,1.76v7.06s5.09,4.82,4.83,8-4.83,5.79-11.73,1.56a20.1,20.1,0,0,1-6-6.24l.06-15.1s-1.73,2.4-4.66.22a6.32,6.32,0,0,1-1.36-8.42,4.89,4.89,0,0,1,3.41-2.19,3,3,0,0,1,3.14,3v.83s2.14.33,2.28-3.85c.08-2.32,2.85-6,5.56-8.32C224,149.61,229.87,149.56,231.78,142.4Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.33,158.58a1.88,1.88,0,0,1-1.15,1.82c-.67.22-1.24-.25-1.27-1a1.89,1.89,0,0,1,1.15-1.83C223.72,157.32,224.3,157.78,224.33,158.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.14,168.17l3.57.36a2.49,2.49,0,0,1-2.33,2.1C225.4,170.53,224.84,169.43,225.14,168.17Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.83,152.5l-2.45-1.31c.44-.93,1.36-1.39,2-1A1.75,1.75,0,0,1,234.83,152.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.86,156.13l2.45-2.63c-.45-.68-1.36-.66-2,.07A2.22,2.22,0,0,0,220.86,156.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.54,156.49a1.87,1.87,0,0,1-1.15,1.83c-.67.22-1.24-.25-1.27-1a1.88,1.88,0,0,1,1.15-1.83C233.93,155.23,234.51,155.7,234.54,156.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.71 156.89 228.9 165.27 232.74 162.87 228.71 156.89",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.86,177c-3.1.36-9.48,0-10.48-2.69a5.53,5.53,0,0,0,2.24,3.12c1.91,1.37,8.24,1.8,8.24,1.8Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.41,251.06c3.31-36.15,5.2-56.52,18.3-60.46,1.95.71,3.76,5,4.1,8.11.59,5.26-.12,14.34-3.38,19,0,0-4.11,21.66-5.7,34.13-1.1,8.63-3.47,21.06-2.92,28.06a8.21,8.21,0,0,0,1.62,3.46l2.22,3.69a15.8,15.8,0,0,0,1.5,2.2c.51.59,1.1,1.1,1.65,1.65.41.4.81,1,.47,1.48a1.07,1.07,0,0,1-.5.33,4.56,4.56,0,0,1-4-.38c-.74-.46-1.34-1.13-2.11-1.53a8.23,8.23,0,0,0,1.07,3.67c.44.91.88,1.83,1.37,2.73A23.51,23.51,0,0,1,197.5,300a5,5,0,0,1,.29,3.06,4.41,4.41,0,0,1-3.56,3,7.62,7.62,0,0,1-4.73-.93c-4.93-2.55-6.58-7.67-7.2-12.81a103.53,103.53,0,0,1-1-12.9C181.49,268,181.77,258.1,182.41,251.06Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,186.37a18,18,0,0,0-6,2.48s4.72,9.12,12.82,10.44,8.68-4.13,8.68-4.13C221.43,195.37,216.31,193.17,211,186.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.86,182.71v1.38c3.44,4.48,4.49,8.35,2.59,11.07,0,0,5.67,1.93,6.67-2.23s-6.2-10.9-6.2-10.9A10.76,10.76,0,0,0,223.86,182.71Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150,74.22l-6,3.47a7.31,7.31,0,0,0,.05-.8V75.16c0-3.1-2.17-4.35-4.85-2.81a9.35,9.35,0,0,0-2.9,2.79c-.43-3.9-3.49-5.34-7.19-3.2a16,16,0,0,0-7.26,12.57v2.6a6.86,6.86,0,0,0,.61,3l-5,2.88a6,6,0,0,0-2.7,4.66c0,1.72,1.21,2.42,2.7,1.56L150,80.44a6,6,0,0,0,2.69-4.66C152.7,74.06,151.5,73.37,150,74.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.34,58.28,107,59.55V52.26c0-5.78-4.61-7.17-9.61-4.28h0c-5,2.9-9.07,9.93-9.07,15.71v1.06a4.83,4.83,0,0,0-4.21.65h0a14.41,14.41,0,0,0-6.52,11.3v.48L73,79.84a9.5,9.5,0,0,0-4.3,7.44c0,2.74,1.93,3.85,4.3,2.48L110.34,68.2a9.49,9.49,0,0,0,4.29-7.44C114.63,58,112.71,56.91,110.34,58.28Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.69,267h0c-1.41-1.16-3.58-1.4-6.18-.43-5.21,1.93-10.19,7.94-11.13,13.41-.47,2.74.17,4.83,1.57,6h0l95.55,85.62h0c1.94,1.83,5.08,2.28,8.9.87,7.28-2.7,14.25-11.09,15.55-18.75.69-4-.33-7-2.5-8.59l0,0Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 310.82,
    cy: 276.47,
    rx: 12.32,
    ry: 7.12,
    transform: "translate(-100.42 339.15) rotate(-50.32)",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.71,246.31a11.6,11.6,0,0,0-6.72,8.11,3.7,3.7,0,0,0,.94,3.62h0l29.13,24.17h0a3.69,3.69,0,0,0,3.73.27,11.63,11.63,0,0,0,6.73-8.11,3.7,3.7,0,0,0-.95-3.63l-29.12-24.16h0A3.7,3.7,0,0,0,282.71,246.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.75,283.57l98.64,86.1a21.35,21.35,0,0,1-5,2.76c-3.82,1.41-7,1-8.91-.88h0L303,286c1.42,1.17,3.57,1.39,6.18.43A16,16,0,0,0,313.75,283.57Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.79,153c0-1-.08-2-.16-3s-.12-1.95-.22-2.91c0-.65-.12-1.28-.2-1.93-.17-1.67-.41-3.33-.69-4.9-.12-.72-.25-1.45-.39-2.17s-.28-1.36-.42-2c-.42-1.82-.87-3.6-1.38-5.31-.27-.81-.52-1.62-.79-2.41a1.77,1.77,0,0,1-.12-.37c-.29-.79-.57-1.55-.87-2.3s-.68-1.72-1.08-2.54c-.28-.61-.54-1.2-.86-1.79a9.55,9.55,0,0,0-.64-1.28,17.44,17.44,0,0,0-.82-1.54,2.77,2.77,0,0,0-.2-.34c-.24-.44-.52-.89-.78-1.33s-.37-.56-.54-.84a42.88,42.88,0,0,0-4.25-5.64c-.27-.3-.54-.6-.78-.89l-.67-.7c-.27-.29-.57-.56-.87-.86a28.72,28.72,0,0,0-2.56-2.3c-.42-.36-.86-.7-1.31-1s-.88-.66-1.35-1a22.92,22.92,0,0,0-2.2-1.43l-.59-.37-.12-.1h0l-13.79-8.1h0l-.2-.12A43.8,43.8,0,0,0,272.93,88c-11.45,0-24.36,3.75-38.05,11.63-47,27.15-85.11,93.16-85.11,147.45,0,27.08,9.47,46.12,24.78,55l.14.07v0l13.81,8.08s0,0,0,0l.16.09v0l.2.11.22.12c.66.38,1.32.73,2,1.06s1.7.79,2.56,1.12a21.31,21.31,0,0,0,2.35.87,11.66,11.66,0,0,0,1.24.37,9.22,9.22,0,0,0,1.36.4,13.88,13.88,0,0,0,1.38.34,7.43,7.43,0,0,0,1,.22c.59.12,1.23.25,1.85.33a1.54,1.54,0,0,0,.42.07c.73.12,1.48.23,2.21.3,12.68,1.33,27.42-2.25,43.2-11.35,47-27.14,85.15-93.18,85.15-147.45C333.86,155.57,333.83,154.29,333.79,153ZM178.67,281.1a82.75,82.75,0,0,1-2.88-22.28c0-51.44,37.64-116.65,82.19-142.37a79.61,79.61,0,0,1,20.85-8.63,46.21,46.21,0,0,1,10.73-1.35,33.45,33.45,0,0,1,5.44.42l.15,0c9.12,10.79,10.46,28.07,10.46,37.31,0,51.44-37.6,116.65-82.17,142.36-11.34,6.54-22.24,10-31.59,10a21.84,21.84,0,0,1-5.75-.73h0A40.61,40.61,0,0,1,178.67,281.1Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.62,153.23c0,27.33-10.62,58.53-27.26,85.65-.78,1.29-1.58,2.55-2.4,3.82-.69,1.09-1.4,2.18-2.14,3.26-1.56,2.32-3.14,4.61-4.8,6.85-.78,1.07-1.57,2.13-2.38,3.17s-1.76,2.29-2.66,3.42c-1.71,2.16-3.48,4.26-5.28,6.31-1.18,1.37-2.39,2.71-3.61,4-9.8,10.54-20.51,19.44-31.65,25.86-2.13,1.23-4.23,2.35-6.32,3.36a63.21,63.21,0,0,1-21.67,6.47c-1.22.12-2.42.17-3.58.17-.62,0-1.21,0-1.8-.05H206a28,28,0,0,1-3.38-.35c-.55-.08-1.09-.17-1.61-.29a15.93,15.93,0,0,1-1.55-.38,24.85,24.85,0,0,1-13.35-8.64,21.76,21.76,0,0,0,5.74.73c9.35,0,20.25-3.45,31.59-10,44.57-25.71,82.17-90.92,82.17-142.36,0-9.24-1.34-26.52-10.46-37.31l-.15,0c11.62,1.86,18.23,9.76,21.95,18.89a53.45,53.45,0,0,1,2.54,8c0,.15.07.3.1.45.12.49.24,1,.33,1.48s.19,1,.28,1.44a3.49,3.49,0,0,1,.07.37q.15.78.27,1.53c.29,1.91.53,3.77.69,5.55,0,.52.09,1,.12,1.5s.06.75.08,1.11c0,.15,0,.31,0,.46,0,.4.05.79.07,1.18,0,.11,0,.21,0,.33,0,.49,0,1,.05,1.45C321.61,151.52,321.62,152.4,321.62,153.23Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.32,309.6l-12.78-7.51c-15.31-8.95-24.78-28-24.78-55,0-24.22,7.59-50.75,20.15-75.11l14.55,8.37c-12.57,24.36-20.9,50.62-20.9,74.83C163.56,281.65,172.57,300.43,187.32,309.6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.06,101.85l-.12-.1h0l-13.78-8.1h-.05l-.19-.12A43.83,43.83,0,0,0,272.93,88c-11.44,0-24.36,3.74-38.05,11.63-26,15-49.37,42-65,72.36l14.48,8.52-.31.6c15.65-30,38.86-57.13,64.63-73.37,23.33-14.7,45.47-14.9,60.93-5.5Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M314.21,148.87c0,51.44-37.64,116.65-82.19,142.37a79.61,79.61,0,0,1-20.85,8.63,46.15,46.15,0,0,1-10.73,1.35,30.59,30.59,0,0,1-10.9-1.86c-5.53-4.64-8.87-11.36-10.87-18.26a82.75,82.75,0,0,1-2.88-22.28c0-51.44,37.64-116.65,82.19-142.37a79.61,79.61,0,0,1,20.85-8.63,46.21,46.21,0,0,1,10.73-1.35,30.78,30.78,0,0,1,10.9,1.85c5.54,4.64,8.88,11.37,10.88,18.27A83.09,83.09,0,0,1,314.21,148.87Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-16)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.71,303.44h0l-8.06-4.61a2.74,2.74,0,0,1-1.09-2.46V145.64a8,8,0,0,1,1.44-4.23l7.87,4.55a8,8,0,0,0-1.3,4.08V301A2.67,2.67,0,0,0,169.71,303.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.11,74.36a3.24,3.24,0,0,0-2,.5L172.41,143.38a7.84,7.84,0,0,0-2.54,2.58L162,141.41a7.52,7.52,0,0,1,2.42-2.44l118.66-68.5a3.4,3.4,0,0,1,1.72-.53,2.06,2.06,0,0,1,1,.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.42,143.37l118.66-68.5c2.12-1.23,3.85-.24,3.85,2.22v151a8.51,8.51,0,0,1-3.85,6.66L172.42,303.18c-2.13,1.22-3.85.23-3.85-2.23V150A8.5,8.5,0,0,1,172.42,143.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.51,148.05,285,86.56c1.9-1.1,3.45-.21,3.45,2V224.12a7.63,7.63,0,0,1-3.45,6l-106.5,61.38c-1.91,1.1-3.46.21-3.46-2V154A7.65,7.65,0,0,1,178.51,148.05Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-16)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.73,269c-15.76-55.57-15.93-64.67-15-71.18,14.31-3.45,20.54,6.35,24.38,22.9,1.85,8,7.13,38.22,10.41,50.84,2.88,11.09,6.49,23,10.8,30.92a4.74,4.74,0,0,0,3.54,2.47c4,.57,5.2,2.83,8.47,4.49,2.56,1.31,4.45,1,4.33,1.88a5,5,0,0,1-4.05,4c-1.37.24-2.43,0-4.79-.32a26.79,26.79,0,0,0,7,6.42c6.28,4.07,8.24,10.33-2.65,13.35-4.27,1.18-12.24-.17-21.7-12.95a72.54,72.54,0,0,1-7.8-14.68C275.27,293.39,270.89,280.1,267.73,269Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.48,204.19s-15.6,5.54-19.64,7.44c10.22,12.33-2,46-2,46l6.57,22.69c-7.07,12.34,48.35-10.57,49.36-17.3,8.16-20.63,9.75-29.89,9-35.53-1.62-12.78-9.26-21.17-20-29.69Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.39,280.32c13.32-.35,43.35-11.85,49.36-17.3,8.16-20.63,9.75-29.89,9-35.53",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.53,190.49l-25.73,8.08a26.22,26.22,0,0,1-34.08-25v-5.37h0c0-18.45,12.95-36.88,28.93-41.16l2.16-.58c16-4.29,28.94,7.2,28.94,25.66v5.15C266.75,173.75,266.53,190.49,266.53,190.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.67,134.66c-1.57-1.55-4.24-1-5.95,1.31l3.18,3.14a3.75,3.75,0,0,0-2.18.43,6.5,6.5,0,0,0-3.25,6.63l8.24-4.21a4.25,4.25,0,0,0-.17-.57C218.11,139.13,218.2,136.17,216.67,134.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.48,140.83c3,1.91,7.06,5.36,6.67,24.77-.32,16.44-4.92,21.72-7.22,23.5s-6.76,2.26-11.08,2.59v10.37s7.47,7.09,7.1,11.69-7.1,8.5-17.23,2.29a29.68,29.68,0,0,1-8.79-9.16l.09-22.19s-2.54,3.54-6.85.34a9.3,9.3,0,0,1-2-12.38,7.14,7.14,0,0,1,5-3.21,4.34,4.34,0,0,1,4.6,4.43v1.22s3.15.49,3.36-5.65c.12-3.41,4.19-8.8,8.17-12.22C244.08,151.41,252.68,151.34,255.48,140.83Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.54,164.58a2.77,2.77,0,0,1-1.69,2.69c-1,.32-1.82-.37-1.87-1.54a2.78,2.78,0,0,1,1.69-2.68C243.65,162.73,244.49,163.42,244.54,164.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.73,178.68l5.24.53c-.44,1.85-2,3.23-3.41,3.08S245.29,180.53,245.73,178.68Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,155.66l-3.6-1.92c.66-1.37,2-2,3-1.51S260.62,154.29,260,155.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.44,161l3.6-3.85c-.66-1-2-1-3,.09A3.26,3.26,0,0,0,239.44,161Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.54,161.52a2.77,2.77,0,0,1-1.69,2.69c-1,.31-1.82-.37-1.87-1.54a2.78,2.78,0,0,1,1.69-2.68C258.65,159.67,259.49,160.36,259.54,161.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.97 162.11 251.26 174.42 256.9 170.89 250.97 162.11",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.85,191.69c-4.56.53-13.93-.07-15.39-3.95a8.14,8.14,0,0,0,3.29,4.58c2.8,2,12.1,2.65,12.1,2.65Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,300.44c4.87-53.11,7.64-83,26.88-88.81,2.87,1,5.53,7.38,6,11.91.86,7.72-.18,21.07-5,27.94,0,0-6,31.82-8.37,50.13-1.62,12.68-5.1,30.95-4.29,41.23.16,1.94,1.4,3.45,2.38,5.08l3.26,5.41a23.14,23.14,0,0,0,2.21,3.24c.74.87,1.61,1.62,2.42,2.42.6.59,1.19,1.51.69,2.18a1.54,1.54,0,0,1-.73.48,6.72,6.72,0,0,1-5.92-.55c-1.09-.68-2-1.67-3.11-2.25a12,12,0,0,0,1.58,5.38c.64,1.35,1.28,2.7,2,4a34.26,34.26,0,0,1,2.11,4.08,7.45,7.45,0,0,1,.43,4.51,6.51,6.51,0,0,1-5.24,4.38,11.25,11.25,0,0,1-6.95-1.38c-7.23-3.74-9.65-11.26-10.57-18.81a151.08,151.08,0,0,1-1.41-18.95C181.61,325.35,182,310.77,183,300.44Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.93,205.41a26.59,26.59,0,0,0-8.86,3.64s6.94,13.4,18.84,15.34,12.74-6.07,12.74-6.07C240.28,218.63,232.75,215.41,224.93,205.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.85,200v2c5.05,6.58,6.6,12.26,3.8,16.26,0,0,8.34,2.83,9.8-3.27s-9.1-16-9.1-16A15.81,15.81,0,0,0,243.85,200Z",
    style: {
      fill: "#455a64"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.59,248c6.93-.77,9.59,1.26,12.17,7,2.46,5.48,10,22,9.62,25.85s-16.14,20.24-16.14,20.24l-4.49-5.46,9.74-16.38-7.75-16.53Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "367.67 242.62 368.97 256.22 381.12 255.46 380.15 240.38 367.67 242.62",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.1,216.48a6,6,0,0,1,0-1.93,5.81,5.81,0,0,1,7.66-4.42,5.68,5.68,0,0,1,3.23-6.22,7.15,7.15,0,0,1,5.59.22,4.4,4.4,0,0,1,2.43,2.09,6.13,6.13,0,0,1,11.17,1.5c1.85-.41,4.46.41,5.29,2.25.94,2.09-.21,4.68.22,6.87.28,1.42.89,2.75,1.15,4.19a34.16,34.16,0,0,1,.45,4.85c.27,6.71-15.32,11.07-15,15.68L366,231.45c0-.42-1.18-1.47-1.44-1.82-.5-.67-.94-1.38-1.4-2.08a13,13,0,0,0-5.72-4.58,10.55,10.55,0,0,1-4.1-3.35A7.52,7.52,0,0,1,352.1,216.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.65,227.7s-2.69,4-2.34,4.42a6.36,6.36,0,0,0,2.06.88Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.87,215c-2.61,1.33-7.13,3.78-8.3,13.26-1.19,9.72,1,13.1,2.36,14.37.91.86,5.61,1.17,8.06.43,3.06-.94,9.71-4.16,12.82-9.18,3.66-5.91,4.42-13.78.19-16.86C376.05,212.71,369.09,213.91,366.87,215Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.18,242.84c1.1.6,4.23.85,6.56.51l-.08-1.74a17.39,17.39,0,0,1-3.1,1A11.41,11.41,0,0,1,361.18,242.84Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.73,214.74a10.21,10.21,0,0,0-3.05,1.76,4.14,4.14,0,0,0-1.08,1.38,3.32,3.32,0,0,0-.22,1.56,4.21,4.21,0,0,0,2.45,3.39,4,4,0,0,0-.66,3.38,8,8,0,0,0,2.4,3.45.59.59,0,0,0,.2.15.51.51,0,0,0,.43-.13c1.64-1.1,2.66-3,5-2.23,3.05,1,2.9,4.76.51,7.1a5.16,5.16,0,0,1-3.19,1.51,2.52,2.52,0,0,1-1.68-.59s.09,4.9,4.35,6.85a17,17,0,0,0,9.11.11c1.61-2.05,4.31-4.66,6.53-7,7.31-7.69,7.73-18.86-3.06-22.39-.37-.12-.74-.23-1.12-.33a22.92,22.92,0,0,0-10.61-.23,22.61,22.61,0,0,0-5,1.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.38,233.09A2.23,2.23,0,0,1,364,230.2a2.3,2.3,0,0,1,2.94-1.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.58,419.59a40.86,40.86,0,0,1,1.1,4.06c.31,1.51.75,4,.22,5.16s-2.59,1.87-5.78,1.84c-2.06,0-5.28,1.39-7.49,2.62s-7,1.78-9.42,1.49c-2.84-.33-5.78-2-6.24-3.15s-.84-2.79,6.84-5.25c.07,0,9.3-3,12.54-6.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.58,419.8l-1.47-.18-6.76.14c-3.24,3.57-12.47,6.58-12.54,6.6l-1.23.41c-1.33,1.08-.2,2.91,3,3.19s13.05-3,15.24-4.09A6.55,6.55,0,0,0,366.58,419.8Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.58,416.9s0,1.85,0,2.9-1.24,2.63-4.47,2.52c-2.27-.08-3.85-.69-3.76-2.56v-2.69Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.28,407.44c.58.24.7,1.36.73,3.59,0,1.68.3,4.63-1.69,5.16s-4.86.16-6.09-1.46c-1.52-2-2.54-3.8-4.72-6.27-1.9-2.15-4-4.16-4.67-7.13-.64-2.67,0-3.81,1.82-4.53s3.49-.13,6,2a12.29,12.29,0,0,0,2.26,1.19C383.61,400.49,387.7,407.2,388.28,407.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.33,405.38l-.07,2.73s-1.83,3.58-6.91,0c-.11-.26-.56-5.55-.56-5.55Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.94,400a12.29,12.29,0,0,1-2.26-1.19h0c-2-.66-6.36.1-4.41,3.07a23.09,23.09,0,0,0,6.08,6.25c2.3,1.13,3.11-.27,3.11-.27l-.82-6.41A4.94,4.94,0,0,0,381.94,400Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,367.58a64.94,64.94,0,0,0-3-14.13s1.72-12.06,3.07-23.64c3.18-27.16,1.06-27.59-2.78-37,0,0-34.82-4.48-36.27,10-1.82,18-1,53-.69,59.4s.82,9.29,2.72,22.69c1.45,10.2,2.82,32.49,2.82,32.49,4.56,2.63,9-.45,9-.45s4.36-27.42,4.26-34.8A63.29,63.29,0,0,0,368.82,366s3-29.39,3.71-34.06c0,0,.84,9.37,1.15,15.77s2,12.54,3.57,24.45c1.32,10.33,3.52,31.89,3.52,31.89,4.57,2.63,7.76,1.44,7.76,1.44S393.05,376.54,392,367.58Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M392,367.58a64.94,64.94,0,0,0-3-14.13s1.72-12.06,3.07-23.64c3.18-27.16,1.06-27.59-2.78-37,0,0-34.82-4.48-36.27,10-1.82,18-1,53-.69,59.4s.82,9.29,2.72,22.69c1.45,10.2,2.82,32.49,2.82,32.49,4.56,2.63,9-.45,9-.45s4.36-27.42,4.26-34.8A63.29,63.29,0,0,0,368.82,366s3-29.39,3.71-34.06c0,0,.84,9.37,1.15,15.77s2,12.54,3.57,24.45c1.32,10.33,3.52,31.89,3.52,31.89,4.57,2.63,7.76,1.44,7.76,1.44S393.05,376.54,392,367.58Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M372.53,331.89l1.68-12.7a21.88,21.88,0,0,0,13.52-4.71s-2.28,4.64-11.53,6.67l-1.81,13.07-.65,14.4Q373.28,340.18,372.53,331.89Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.51,253.66c-1.18-3.5-3.59-5.56-8.92-5.62l-.94,0c-.38,2-6.63,3.74-12.3,1.74-.78.14-3.48.44-4.72.61l-2.71.39c-4.12,1.35-5.94,8.52-6.34,19.87s-2.09,35.64-2.09,35.64,8.87,4.76,22.86,2.92c12.53-1.65,18.09-9,17.66-8.08a122.61,122.61,0,0,0-7.16-18.23C392.45,266.73,392.27,258.87,390.51,253.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.42,309.65a48.77,48.77,0,0,0,6.93-.41c11.43-1.5,17.17-7.76,17.65-8.14a116.85,116.85,0,0,0-7.15-18.17c3.34-8.19,4.94-14.24,5.48-18.9-.54,3.4-5.56,16.56-12.13,20.5,0,0,3.7.58,6.87,4.93S386.64,308.72,368.42,309.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.63,250.42c-5.46.69-9.78,1.83-12.17,7-4,8.83-8.41,16.08-11.59,19.49-3.4,3.64-17.34,10-20.48,9.53s-6.27-4.12-7.89-3.19,1.38,4.44,1.18,5.23-5.89.37-8.58-1.53-3.69,2-.21,6.1,10,4.4,17.13,3,20.52-5.17,26-9.66c6.61-5.44,8.86-9.56,11.67-14.44C368.84,261.47,363.63,250.42,363.63,250.42Z",
    style: {
      fill: "#ffa8a7"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeoplesearchAmico);
export default __webpack_public_path__ + "static/media/People search-amico.f76d946083d6c916d013c569e2d9ff9d.svg";
export { ForwardRef as ReactComponent };